import { render, staticRenderFns } from "./PhotoUploadBeforeAfterTable.vue?vue&type=template&id=83f7f036&scoped=true"
import script from "./PhotoUploadBeforeAfterTable.vue?vue&type=script&lang=js"
export * from "./PhotoUploadBeforeAfterTable.vue?vue&type=script&lang=js"
import style0 from "./PhotoUploadBeforeAfterTable.vue?vue&type=style&index=0&id=83f7f036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f7f036",
  null
  
)

export default component.exports